import {
  Text,
  Divider,
  IconPeopleCircle,
  GreyGrey10,
  GreyGrey30,
  GreyGrey40,
  GreyGrey60,
  GreyGrey70,
  GreyGrey90,
  IndigoIndigo50,
  Primary13SemiBold,
  Primary13Regular,
  Primary24SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { formatInteger } from '@sequencehq/utils'
import { EmptyState } from 'modules/Insights/common/EmptyState'
import { WidgetLoading } from 'modules/Insights/common/WidgetLoading/WidgetLoading'
import { Container } from 'modules/Insights/widgets/TotalCustomersWidget/Container'
import { ProgressBar } from 'modules/Insights/widgets/TotalCustomersWidget/ProgressBar'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useQuery } from '@sequencehq/api'

const TotalCustomersWidget: React.FC = () => {
  const customerTotalsQuery = useQuery(
    dashboard20240730Client.getInsightsCustomerTotals
  )
  const totalCustomersData = customerTotalsQuery.data

  if (
    customerTotalsQuery.isPending ||
    !totalCustomersData ||
    customerTotalsQuery.isError
  ) {
    return <WidgetLoading />
  }

  const Tooltip = (
    <>
      <Box
        backgroundColor={GreyGrey10}
        padding="10px"
        borderBottom={`1px solid ${GreyGrey30}`}
      >
        <Text {...Primary13SemiBold} color="gray.70">
          Customer breakdown
        </Text>
      </Box>
      <Box padding="10px">
        <Flex justifyContent="space-between">
          <Text {...Primary13Regular}>New customers (awaiting billing)</Text>
          <Text {...Primary13SemiBold}>
            {formatInteger()(totalCustomersData.numCustomersNeverBilled)}
          </Text>
        </Flex>
        <Divider borderColor={GreyGrey30} margin="10px 0" />
        <Flex justifyContent="space-between">
          <Text {...Primary13Regular}>Past customers (no longer billed)</Text>
          <Text {...Primary13SemiBold}>
            {formatInteger()(totalCustomersData.numCustomersNoLongerBilled)}
          </Text>
        </Flex>
      </Box>
    </>
  )

  return (
    <Container>
      <Text color={GreyGrey60} {...Primary13SemiBold} mb={2}>
        Total Customers
      </Text>
      <Text color={GreyGrey90} {...Primary24SemiBold} mb={2}>
        {formatInteger()(totalCustomersData.total)}
      </Text>
      {totalCustomersData.total ? (
        <>
          <ProgressBar
            label="Actively billed"
            value={totalCustomersData.numCustomersWithActiveSchedule}
            total={totalCustomersData.total}
            color="white"
            backgroundColor={IndigoIndigo50}
          />
          <Box
            width="100%"
            height="1px"
            borderWidth="1px"
            borderStyle="dashed"
            borderColor={GreyGrey40}
            margin="16px 0"
          />
          <ProgressBar
            label="Not actively billed"
            value={
              totalCustomersData.numCustomersNeverBilled +
              totalCustomersData.numCustomersNoLongerBilled
            }
            total={totalCustomersData.total}
            color={GreyGrey70}
            backgroundColor={GreyGrey40}
            tooltip={Tooltip}
          />
        </>
      ) : (
        <EmptyState label="No customers" Icon={<IconPeopleCircle />} />
      )}
    </Container>
  )
}

export default TotalCustomersWidget
